import Commons from '../Services/Common/Common';

export const Layout_Schema = {
  mapper: {
    search1: {
      value1: (ctx) => Commons.EncryptAES(ctx.lanCd ?? 'kr'),
      value2: (ctx) => ctx.userInfo?.userid ?? '',
      value3: () => Commons.EncryptAES(''),
      value4: (ctx) => Commons.EncryptAES(ctx.firebaseToken),
      value5: () => Commons.EncryptAES(Commons.IsMobile() ? 'Y' : 'N'),
      value6: () => Commons.EncryptAES(Commons.DeviceCheck()),
    },
    search2: {
      CoCd: (context) => Commons.EncryptAES(context.userInfo?.coCd),
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
      TbmYn: (context) => Commons.EncryptAES(context.userInfo?.tbmYn),
      UserId: (context) => context.userInfo?.userid,
    },
    search3: {
      CustCd: (context) => Commons.EncryptAES(context.search?.custCd),
      SearchText: () => Commons.EncryptAES(''),
    },
    search4: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search5: {
      WorkStopCd: (context) => Commons.EncryptAES(context.workStopCd),
    },
    search6: {
      DepCd: (context) => Commons.EncryptAES(context.userInfo?.depCd),
    },
    /** 보호구 수령현황 조회 GetEisBasicR1 — 미서명(issuSign !== 'Y') 건 확인용 */
    search7: {
      DateFrom: (context) => Commons.EncryptAES(context.dateFrom ?? '') || '',
      DateTo: (context) => Commons.EncryptAES(context.dateTo ?? '') || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.userInfo?.custCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    save1: {
      Id: (_, context) => context.userInfo?.userid,
      CoCd: (_, context) => Commons.EncryptAES(context.userInfo?.coCd),
      FcmToken: (_, context) => Commons.EncryptAES('0'),
      DeviceType: (_, context) => Commons.EncryptAES(Commons.DeviceCheck()),
    },
  },
};
